import * as React from 'react'
import { ResponsiveImage } from './ResponsiveImage'
import type { ResponsiveImageData } from '../../types/responsiveImage'

export interface NewsItemCardProps {
  id: string
  title: string
  image?: ResponsiveImageData
  path: string
  headingLevel?: 'h2' | 'h3'
  className?: string
}

export const NewsItemCard = ({
  title,
  image,
  path,
  headingLevel = 'h3',
  className = '',
}: NewsItemCardProps) => {
  const Heading = headingLevel
  return (
    <article
      className={`group relative flex h-full flex-col overflow-hidden bg-blue-300 md:h-[316px] md:flex-row ${className}`}
    >
      <div className="order-2 flex-1 p-4 md:order-1 md:w-[325px] md:flex-none md:shrink-0 md:p-6">
        <Heading className="text-lg leading-normal text-blue-900 group-hover:underline md:text-2xl md:font-medium md:leading-snug">
          <a
            className="after:absolute after:inset-0 after:z-10 after:content-['']"
            href={path}
          >
            {title}
          </a>
        </Heading>
      </div>
      <div className="relative order-1 aspect-[280/248] overflow-hidden md:order-2 md:aspect-auto md:h-full md:min-w-0 md:flex-1">
        {image ? (
          <ResponsiveImage
            data={image}
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
            loading="lazy"
          />
        ) : (
          <div className="absolute inset-0 bg-slate-500/20" />
        )}
      </div>
    </article>
  )
}
